import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-foreground-50">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold mb-4">{t('footer.about')}</h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {t('footer.aboutDesc')}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
                  {t('nav.about')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold mb-4">{t('footer.categories')}</h3>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-2">
              <li className="text-sm text-foreground-300">contact@bikadongman.com</li>
              <li className="text-sm text-foreground-300">微信公众号：bikadongman</li>
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}